<ng-template #UnifyContacts>
    <div class="centered-content">
        <div
            style="display: flex; justify-content: center; align-items: center; flex-direction: column; background: #e6e6e6">
            <div
                style="max-width: 736px; width: 100%; height: auto; margin: 0 auto; padding: 20px 44px 40px; background: #fff">
                <div nxLayout="grid maxwidth">
                    <div nxRow>
                        <div nxCol="12" style="text-align: center;">
                            <h3 nxHeadline="subsection-medium" translate>
                                profile.texts.warning</h3>
                            <p translate>
                                profile.texts.unify-contacts
                            </p>
                        </div>
                    </div>
                    <div nxRow rowJustify="center">
                        <button nxButton="primary normal" (click)="unifyContacts()">
                            <span translate>profile.texts.agree</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</ng-template>